import React, { useState, useEffect } from 'react';

/**
 * Componente que sigue el ratón y muestra un texto cerca de él.
 * @param {string} text El texto que seguirá al ratón.
 * @param {boolean} show Si debe ser visible o no.
 */
const MouseFollower = ({ text, show }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Función que se ejecuta cuando el ratón se mueve
  const handleMouseMove = (event) => {
    setMousePosition({
      x: event.clientX,
      y: event.clientY,
    });
  };

  useEffect(() => {
    if (show) {
      // Añadir el evento mousemove solo cuando el mensaje debe mostrarse
      document.addEventListener('mousemove', handleMouseMove);
      // Cambiar el cursor
      document.body.style.cursor = 'crosshair';

      // Limpiar el evento y el estilo del cursor cuando el componente se desmonte o se oculte
      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.body.style.cursor = 'default';
      };
    }
  }, [show]);

  // Si no se debe mostrar, no renderizamos nada
  if (!show) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: mousePosition.y - 10, // Ajuste de posición
        left: mousePosition.x - 10,
        minWidth: '200px',
        pointerEvents: 'none', // El mensaje no interfiere con otros elementos del DOM
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        padding: '5px',
        borderRadius: '5px',
        fontSize: '14px',
        color: '#fff',
      }}
    >
      {text}
    </div>
  );
};

export default MouseFollower;